import React from 'react';
import CapacityPlanningPage from '../../features/capacity-planning/pages/CapacityPlanningPage';

const AdminCapacityPlanning = () => <CapacityPlanningPage />;

export default AdminCapacityPlanning;


